import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=61feb53e&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=61feb53e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61feb53e",
  null
  
)

export default component.exports